import createMediaApi from '@rhg/libs/api/create-media-api';
import useAuth from '@rhg/libs/auth0/use-auth';
import { invalidateQueryKey, useMutation } from '@rhg/libs/react-query';
import { useActiveCircle } from '../use-active-circle';
import { mediaPackQueryOptions } from '../use-media-pack';
import { programQueryOptions } from '../use-program';
import { publicProgramQueryOptions } from '../use-public-program';

export interface ResetPackClassProgressParameters {
    packClass: string;
    programId?: string;
}
export function useResetPackClassProgress() {
    const { getAccessTokenSilently } = useAuth();
    const { activeCircle, activeCircleId } = useActiveCircle();

    const { mutate, mutateAsync, ...otherProps } = useMutation({
        mutationFn: async ({ packClass }: ResetPackClassProgressParameters) => {
            const api = createMediaApi(getAccessTokenSilently);
            const response = await api.patchRecipientPackClassPrograms({
                circleAuthorizationToken: activeCircle!.authorizationJWT!,
                _class: packClass,
                recipientId: activeCircle!.recipient.id,
                mediaUpdatePackClassPrograms: {
                    resetProgress: true,
                },
            });
            return response;
        },
        onSuccess: (_, { packClass, programId }) => {
            invalidateQueryKey(
                mediaPackQueryOptions.queryKey(packClass, activeCircleId)
            );

            if (programId) {
                invalidateQueryKey(
                    programQueryOptions.queryKey({
                        programId,
                        circleId: activeCircleId,
                    })
                );
                invalidateQueryKey(
                    publicProgramQueryOptions.queryKey(programId)
                );
            }
        },
    });
    return {
        resetPackClassProgress: mutate,
        resetPackClassProgressAsync: mutateAsync,
        ...otherProps,
    };
}
